import { type CustomerProfile } from '../types/customer-profile';

export const getProfileDisplayName = (customerProfileData: CustomerProfile | null | undefined) => {
  if (customerProfileData?.nickname) {
    return customerProfileData?.nickname;
  }

  if (customerProfileData?.firstName && customerProfileData?.firstName) {
    return `${customerProfileData?.firstName} ${customerProfileData?.lastName}`;
  }

  return customerProfileData?.lastName || null;
};
